import React, {Component} from 'react';
import { Button, Col } from 'antd';
import { StyledCard } from './style';
import ReactMarkdown from 'react-markdown'
import { fetchPost } from '../../actions/categories'
import { StyledContent } from '../../styles/mixins'


class ViewPost extends Component {

    state = {
        post: null,
        isLoading: true,
    }

    async componentWillMount(){
        const postResponse = await fetchPost(this.props.match.params.slug)
        if (postResponse && postResponse.data && postResponse.data.data && postResponse.data.data.posts && postResponse.data.data.posts.length > 0) {
            this.setState({
                post: postResponse.data.data.posts[0],
                isLoading: false,
            })
        } else {
            this.setState({
                isLoading: false,
            })
        }
    }
  
    onBackToTrade = (tradeId) => {
        this.props.history.push(`/trades/${tradeId}`);
    }

    render() {
        const { post, isLoading } = this.state
        return (
            <StyledContent>
                <StyledCard title={<Col sm={24}>{post ? post.title : ''} <span>{post ? post.postDate : ''}</span>{post && post.trade && <Button style={{float: 'right'}} onClick={() => this.onBackToTrade(post.trade.tradeIdentifier)}>Back to Trade</Button>}</Col>} bordered={false}>
                   
                    {
                        <div className="postView"><ReactMarkdown escapeHtml={false} source={post && post.content} /></div>
                    }
                    {
                        !isLoading && !post && <div>Post not found.</div>
                    }
                </StyledCard>
            </StyledContent>
        )
    }
}
export default ViewPost



// WEBPACK FOOTER //
// ./src/components/categories/ViewPost.js